import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import { NewsboardPostAction } from '../NewsboardPostAction'
import { QA_NAME_LIKE_ACTION } from '../NewsboardPostFooter.constants'
import { POST_REPORTS_LIKES_TAB } from '../NewsboardPostReport'

import { addLike, deleteLike } from './NewsboardPostLike.api'
import { getActionPermission, getLikeCount } from './NewsboardPostLike.utils'

import LikeIcon from '../../../../../icons/like.svg'
import LikedIcon from '../../../../../icons/liked.svg'

function NewsboardPostLike({ data, onOpenReport }) {
  const [liked, setLiked] = useState(data.is_liked)
  const [prevIsLiked, setPrevIsLiked] = useState(data.is_liked)

  // Sync the optimistic `liked` state when the server value changes, during
  // render rather than in an effect (React re-renders before painting).
  if (data.is_liked !== prevIsLiked) {
    setPrevIsLiked(data.is_liked)
    setLiked(data.is_liked)
  }

  const { t } = useTranslation()

  const Icon = liked ? LikedIcon : LikeIcon

  const canViewReport = data?.permissions.can_view_post_report

  const { handleAddErrorNotification } = useNotification()

  const permissionForAction = getActionPermission(data.permissions)

  function handleClickIcon() {
    if (permissionForAction) {
      const api = liked ? deleteLike : addLike

      api({ model: 'post', model_pk: data.uuid })
        .then(() => {
          setLiked(val => !val)
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
    }
  }

  const likeCount = getLikeCount(data, liked)

  function handleClick() {
    if (canViewReport) {
      onOpenReport?.(POST_REPORTS_LIKES_TAB)
    }
  }

  return (
    <NewsboardPostAction
      Icon={Icon}
      disabledAction={!canViewReport}
      disabledIcon={!permissionForAction}
      qaName={QA_NAME_LIKE_ACTION}
      title={t('Newsboard.CommentsLikeKey', {
        count: likeCount,
      })}
      tooltip={t('Newsboard.LikeActionTooltipKey')}
      onClick={handleClick}
      onClickIcon={handleClickIcon}
    />
  )
}

export default NewsboardPostLike
